import types from './types'

export function setIsOpen(isOpen) {
  return { type: types.SET_IS_OPEN, isOpen }
}
